import React, { useState } from "react";
import RichText from "components/rich-text";
import { Card, Accordion } from "react-bootstrap";
import * as styles from "./style.mod.scss";
import { trackDropdownClick } from "helpers/analytics";

const PDPAccordions = ({ item }) => {
  const [open, setOpen] = useState(1);

  return (
    <div className={styles.pdpAccordion}>
      {item?.title && 
        <>
          <Accordion.Toggle
            as={Card.Header}
            eventKey={open}
            className={styles.toggleHeader}
            onClick={() => {
              setOpen(open === 1 ? null : 1);
              trackDropdownClick(open === 1 ? "open" : "close", item.title);
            }}
          >
            <div className={styles.accrodionTitleIcon}>
              <p className={styles.accordionTitle} dangerouslySetInnerHTML={{ __html: item?.title }} />
              <span className={`${styles.accordionIcon} ${1 !== open ? styles.accordionIconOpen : ""}`}>
                {open ? "+" : "-"}
              </span>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={open}>
            <Card.Body className={styles.accordionBody}>
              <RichText
                className={styles.description}
                blocks={item?.content}
              />
            </Card.Body>
          </Accordion.Collapse></>
      }
    </div>
  );
};

export default PDPAccordions;